// extracted by mini-css-extract-plugin
module.exports = {"title":"FeaturedArticles_title__ByYVU"};